<template>
    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 10.8486C0 11.6643 0.924164 12.1369 1.58549 11.6592L7.87752 7.115C8.4302 6.71584 8.4302 5.8928 7.87752 5.49364L1.58549 0.949397C0.924163 0.471772 0 0.944308 0 1.76008V10.8486Z" fill="#04042B"/>
    </svg>
</template>
